import { SERVICE_STATUS } from '@bagonboard/wiseman';

const {
  ASSIGNED,
  BLOCKED,
  CANCELLED,
  COMPLETED,
  DECLINED,
  ON_VERIFICATION,
  PENDING,
  PROCESSING,
} = SERVICE_STATUS;

export default function getServiceStatusDetails(status) {
  switch (status) {
    case ON_VERIFICATION:
      return {
        color: '#1973e8',
        text : 'On verification',
      };
    case PENDING:
      return {
        color: '#1973e8', // blue
        text : 'Pending',
      };
    case ASSIGNED:
      return {
        color: '#1973e8',
        text : 'Assigned',
      };
    case BLOCKED:
      return {
        color: '#d0505f',
        text : 'Blocked',
      };
    case CANCELLED:
      return {
        color: '#d0505f',
        text : 'Cancelled', // red
      };
    case DECLINED:
      return {
        color: '#d0505f',
        text : 'Declined',
      };
    case PROCESSING:
      return {
        color: '#9b770e',
        text : 'Processing',
      };
    case COMPLETED:
      return {
        color: '#39A472',
        text : 'Completed',
      };
    default:
      return {
        color: '#1973e8',
        text : 'Pending',
      };
  }
}
